<div class="modal fade" tabindex="-1" role="dialog" id="dealer-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'parametros.dealer.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.dealer.filtros.nome'}}
            </div>
            <div class="col col-8">
              <app-textbox-nocontainer
                type="text" 
                maxLength='50' 
                placeholder="{{'parametros.dealer.filtros.nomePlaceHolder' | translate}}" 
                [(ngModel)]="filtros.descricao">
              </app-textbox-nocontainer>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.dealer.filtros.CNPJ'}}
            </div>
            <div class="col col-8">
              <app-textbox-nocontainer
                type="text" 
                mascara='00.000.000/0000-00' 
                placeholder="{{'parametros.dealer.filtros.CNPJPlaceHolder' | translate}}" 
                [(ngModel)]="filtros.cnpj">
              </app-textbox-nocontainer>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.dealer.filtros.codDealer'}}
            </div>
            <div class="col col-8">
              <app-textbox-nocontainer
                type="text" 
                maxLength='10'
                placeholder="{{'parametros.dealer.filtros.codDealerPlaceHolder' | translate}}" 
                [(ngModel)]="filtros.codigo">
              </app-textbox-nocontainer>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer"> 
        <button type="button" class="btn btn-outline-secondary" (click)="filtros.descricao = '' || filtros.cnpj = '' || filtros.codigo = ''">
            <i class="fa fa-trash" aria-hidden="true"> 
            </i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>